import * as Icons from "lucide-react";
import { Heart } from "lucide-react";
import { Reveal, Eyebrow } from "./Bits";
import { GUESTS } from "../data/episodeBeats";

const GuestCard = ({ g, dup }) => {
  const Icon = Icons[g.icon];
  return (
    <div className="guest-card" data-testid={dup ? undefined : `reel-guest-${g.id}`} aria-hidden={dup}>
      <div className="guest-art">
        <span className="guest-icon"><Icon size={34} strokeWidth={1.4} /></span>
        <span className="guest-cat" />
        <Heart className="guest-kiss" size={18} fill="currentColor" />
      </div>
      <p className="slate mt-5 text-[var(--coral)]">Clearance Granted</p>
      <h3 className="display text-2xl mt-2">{g.name}</h3>
      <p className="text-sm text-[var(--muted)] mt-1">{g.role}</p>
      <p className="mt-4 italic text-sm">&ldquo;{g.caption}&rdquo;</p>
    </div>
  );
};

export const WelcomeReel = () => (
  <section className="section-tight bg-sand overflow-hidden" data-testid="welcome-reel-section">
    <div className="wrap">
      <Reveal>
        <Eyebrow>The Welcome Committee Reel</Eyebrow>
        <h2 className="display text-3xl md:text-5xl mt-3">No One Gets In Without a Kiss</h2>
      </Reveal>
    </div>
    <div className="reel mt-12" data-testid="welcome-reel">
      <div className="reel-track">
        {GUESTS.map((g) => <GuestCard key={g.id} g={g} />)}
        {GUESTS.map((g) => <GuestCard key={`d-${g.id}`} g={g} dup />)}
      </div>
    </div>
  </section>
);
